<template>
  <div class="overlay">
    <div class="loading-spinner">
      <div class="spin-icon" :style="loadingColor"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiSpinnerLoading',
  props: {
    color: {
      type: String,
      default: 'var(--primary-color)'
    }
  },
  computed: {
    loadingColor () {
      return {
        'border-top-color': this.color,
        'border-left-color': this.color
      }
    }
  }
}
</script>

<style scoped lang="scss">
.overlay {
  width: 100vw;
  height: 100vh;
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  .loading-spinner {
    display: inline;
    position: relative;
    z-index: 999999;
    .spin-icon {
      margin: auto;
      width: 50px;
      height: 50px;
      border: solid 3px transparent;
      border-radius: 80px;
      -webkit-animation: loading-spinner 500ms linear infinite;
      -moz-animation: loading-spinner 500ms linear infinite;
      -ms-animation: loading-spinner 500ms linear infinite;
      -o-animation: loading-spinner 500ms linear infinite;
      animation: loading-spinner 500ms linear infinite;
    }
  }
}

@-webkit-keyframes loading-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes loading-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes loading-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes loading-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
